<template>
  <b-modal ref="modal" :title="clientId ? 'Create New Employer Tag' : 'Create New Tag'" no-close-on-backdrop @close="onCancel">
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>
      <v-form-group :validator="$v.tag.name" label="Name">
        <b-form-input v-model="tag.name" placeholder="Name" />
      </v-form-group>
      <template v-if="isAdmin">
        <v-form-group :validator="$v.selectedClient" label="Client">
          <v-select v-model="selectedClient"
                    :options="clients"
                    placeholder="Client"
                    :clearable="false" />
        </v-form-group>
        <v-form-group :validator="$v.selectedType" label="Type">
          <v-select v-model="selectedType"
                    :options="typeOptions"
                    placeholder="Type"
                    :clearable="false" />
        </v-form-group>
      </template>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="onCancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">Create</b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { required, requiredIf } from "vuelidate/lib/validators";

  import modalFormMixin from 'mixins/modal-form-mixin';

  import TagType, { tagTypeSelectList } from "@/enums/tag-type";

  import { mapActions, mapState } from 'vuex';

  export default {
    mixins: [modalFormMixin],

    props: {
      clientId: {
        type: Number
      }
    },

    validations: {
      tag: {
        name: {
          required
        },
      },
      selectedClient: {
        required: requiredIf(function () { return this.isAdmin })
      },
      selectedType: {
        required
      }
    },

    data() {
      return {
        // TODO - Modify v-select to set value to v-model instead of option
        selectedClient: null,
        selectedType: null,

        typeOptions: [],
      }
    },

    computed: {
      ...mapState('tag', ['tag']),
      ...mapState('client', ['clients']),

      isAdmin() {
        return this.$auth.isInRole("Admin");
      }
    },

    methods: {
      ...mapActions('tag', ['getForForm', 'save', 'clear']),
      ...mapActions('client', ['getClientsForFilter']),

      async beforeShow(id) {
        this.clear();

        this.typeOptions = tagTypeSelectList;
        this.selectedType = this.typeOptions.find(o => o.value === TagType.Employer);

        if (this.isAdmin) {
          await this.getClientsForFilter();
        }

        if (this.clientId) {
          this.tag.clientId = this.clientId;
          this.tag.type = this.selectedType.value;
        }

        if (id) {
          await this.getForForm(id);
          this.selectedClient = this.clients.find(o => parseInt(o.value) === this.tag.clientId);
          this.selectedType = this.typeOptions.find(o => o.value === this.tag.type);
        }
      },

      async onSubmit() {
        if (!this.clientId) {
          this.tag.clientId = this.selectedClient.value;
          this.tag.type = this.selectedType.value;
        }

        await this.save(this.tag);
      },

      onCancel() {
        this.cancel();

        this.$emit('cancel');
      }
    }
  }
</script>